module.exports = __webpack_public_path__ + "static/media/image_39.70b95720.png";